import { render } from "./ProviderBody.vue?vue&type=template&id=76fc656f&scoped=true"
import script from "./ProviderBody.vue?vue&type=script&lang=js"
export * from "./ProviderBody.vue?vue&type=script&lang=js"

import "./ProviderBody.vue?vue&type=style&index=0&id=76fc656f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76fc656f"]])

export default __exports__